export function ProjectFilters() {
  return (
    <>
      <div className="form-group mb-2">
        <label htmlFor="status">Status</label>
        <select className="form-select">
          <option />
        </select>
      </div>
      <div className="form-group mb-2">
        <label htmlFor="addedFrom">Added From</label>
        <select className="form-select">
          <option />
          <option>Manual</option>
          <option>EIH</option>
        </select>
      </div>
    </>
  );
}
